/**
 * FlowController — 异步流程控制器
 *
 * 管理 SSE 流式对话中的中断/暂停/恢复。
 * 当用户在 NPC 发言过程中出牌或跳过时，interrupt() 使当前轮次的所有异步操作失效。
 */

/** 令牌：持有者可检查当前流程是否仍然有效 */
export interface FlowToken {
  /** 该令牌是否仍然有效（未被 interrupt） */
  isValid(): boolean;
}

export class FlowController {
  private generation = 0;
  private paused = false;
  private pauseResolve: (() => void) | null = null;

  /** 获取当前令牌，后续操作通过 token.isValid() 检查是否被中断 */
  getToken(): FlowToken {
    const gen = this.generation;
    return {
      isValid: () => gen === this.generation,
    };
  }

  /** 中断所有进行中的异步操作（令牌失效） */
  interrupt(): void {
    this.generation++;
    // 如果当前暂停中，也一并解除
    if (this.pauseResolve) {
      this.pauseResolve();
      this.pauseResolve = null;
    }
    this.paused = false;
  }

  /** 暂停 */
  pause(): void {
    this.paused = true;
  }

  /** 恢复 */
  resume(): void {
    this.paused = false;
    if (this.pauseResolve) {
      this.pauseResolve();
      this.pauseResolve = null;
    }
  }

  /** 等待暂停解除。返回 false 表示被中断（令牌已失效） */
  async waitIfPaused(token: FlowToken): Promise<boolean> {
    if (!token.isValid()) return false;
    if (!this.paused) return true;

    await new Promise<void>(resolve => {
      this.pauseResolve = resolve;
    });

    return token.isValid();
  }
}
